<div *ngIf="reportType == 'send-reminder2'">
    <div style="margin-left: 80%; margin-bottom: 2%;">
        <!-- <button type="button" mat-raised-button matTooltip="Download Excelsheet" class="btn btn-danger no-print"
            (click)="exportexcel('Letter')" style="margin-top: 2%;">
            Export
        </button> -->

        <button (click)="printPage()" class="no-print" style="margin-top: 2%; margin-left: 2%" mat-raised-button
            color="primary">
            Print
        </button>

        <button class="no-print" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button>
    </div>
    <div class="reminder-container" id="print-section">
        <!-- Header Section -->
        <div class="header-section">
            <div class="header-content">
                <div class="header-top">
                    <div class="organization-info">
                        <h1 class="organization-name">हिंदुस्थान प्रकाशन संस्था</h1>
                        <span class="registration-number">(Reg.No.-BOM-3/1961(GBDSD))</span><br>
                        <span class="office-label">प्रशासकीय कार्यालय:</span> 116-119, शिल्पीन सेंटर, पहिला मजला, 40,
                        ग.द.
                        आंबेकर मार्ग,<br><span class="contact-label"> वडाळा, मुंबई - 400031, दूरध्वनी:</span> 9967570531
                    </div>
                    <div class="header-logo">
                        <img src="../../../assets/img/brand/red.png" alt="Logo" />
                    </div>
                </div>
                <hr class="header-divider" />
                <div class="office-details-single">

                    <!-- <span class="office-label">मुख्य कार्यालय:</span> 5/12, कामत औद्योगिक वसाहत, 396 स्वा. वीर सावरकर
                    मार्ग, प्रभादेवी, मुंबई 400025, <span class="contact-label">दूरध्वनी:</span> 24221440 -->
                </div>
            </div>
        </div>

        <!-- Recipient Section -->
        <div class="recipient-section">
            <div class="recipient-address">
                <div class="field-row">
                    <span class="field-label">प्रति,</span>
                </div>
                <div class="field-row">
                    <span class="field-value" style="font-weight: bolder;font-size: 14px;">{{ selectedRepName }}</span>
                </div>
                <div class="field-row">
                    <span class="field-value">{{selectedRepAddress }}</span>
                </div>
            </div>
            <div class="date-section">
                <div>
                    <div class="field-row">
                        <span class="field-label">दिनांक:&nbsp;</span>
                        <span class="field-value">{{currentDate | date:'dd/MM/yyyy'}}</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Content Section -->
        <div class="content-section">

            <!-- Subject Line -->
            <div class="subject-line">
                <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.subject_line" rows="2" class="form-control"
                    style="width: 100%; padding: 8px; font-weight: bold;">
                </textarea>
                <span *ngIf="!isEditMode">{{letterBodyText.subject_line}}</span>
            </div>

            <!-- Greeting -->
            <div class="greeting" style="text-align: left;">
                <input *ngIf="isEditMode" type="text" [(ngModel)]="letterBodyText.greeting" class="form-control"
                    style="width: 100%; padding: 8px;">
                <span *ngIf="!isEditMode">{{letterBodyText.greeting}}</span>
            </div>



            <!-- Letter Body -->
            <div class="letter-body">

                <!-- Paragraph 1 -->
                <div style="margin-bottom: 15px;">
                    <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph1" rows="4" class="form-control"
                        style="width: 100%; padding: 8px;">
                    </textarea>
                    <p *ngIf="!isEditMode">{{letterBodyText.paragraph1}}</p>
                </div>

                <!-- Paragraph 2 -->
                <div style="margin-bottom: 15px;">
                    <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph2" rows="1" class="form-control"
                        style="width: 100%; padding: 8px;">
                    </textarea>
                    <p *ngIf="!isEditMode">{{letterBodyText.paragraph2}}</p>
                </div>

                <!-- Paragraph 3 -->
                <div style="margin-bottom: 15px;">
                    <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph3" rows="6" class="form-control"
                        style="width: 100%; padding: 8px;">
                    </textarea>
                    <p *ngIf="!isEditMode">{{letterBodyText.paragraph3}}</p>
                </div>

                <!-- Details Heading -->
                <div style="margin-bottom: 15px;">
                    <input *ngIf="isEditMode" type="text" [(ngModel)]="letterBodyText.details_heading"
                        class="form-control" style="width: 100%; padding: 8px; font-weight: bold;">
                    <p class="details-heading" *ngIf="!isEditMode">
                        {{letterBodyText.details_heading}}
                    </p>
                </div>
            </div>

            <!-- Table Section -->
            <div class="table-wrapper" id="print-section">
                <table class="details-table">
                    <thead>
                        <tr style="text-align: center !important;">
                            <th style="height: 40px;">बील क्रमांक</th>
                            <th style="height: 40px;">बील तारीख</th>
                            <th style="height: 40px;"> ग्राहक नाव</th>
                            <th style="height: 40px;">प्रकाशनचे नाव</th>
                            <th style="height: 40px;">प्रकाशनचे तारीख </th>
                            <th style="height: 40px;"> एकूण रक्कम</th>
                            <th style="height: 40px;"> येणे बाकी</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr style="text-align: center !important;"
                            *ngFor="let data1 of getpendingreceiptrep; let k = index">
                            <td style="height: 40px;text-align: center!important;">{{data1.invoice_no}}</td>
                            <td style="height: 40px;text-align: center!important;">{{data1.invoice_date}}</td>
                            <td style="height: 40px;text-align: center!important;">{{data1.advt_name}}</td>
                            <td style="height: 40px;text-align: center!important;">{{data1.ISSUENAME}}</td>
                            <td style="height: 40px;text-align: center!important;">{{data1.ISSUE_DATE | date :
                                "dd-MM-yyyy"}}</td>
                            <td style="height: 40px;text-align: center!important;">{{data1.advt_amt}}</td>
                            <td style="height: 40px;text-align: center!important;">{{data1.remain_amt}}</td>
                        </tr>
                    </tbody>
                    <tfoot>

                        <tr style="text-align: center !important;">
                            <td colspan="5" style="height: 40px;text-align: center!important;"> सर्व एकूण जाहिरात</td>
                            <td style="height: 40px;text-align: center!important;">{{PendingReceiptAmt}}</td>
                            <td style="height: 40px;text-align: center!important;">{{PendingBalanceAmt}}</td>
                        </tr>
                    </tfoot>
                </table>

            </div>

            <!-- Closing Text -->
            <div style="margin-top: 20px;">
                <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.closing_text" rows="2" class="form-control"
                    style="width: 100%; padding: 8px;">
                </textarea>
                <p class="closing-text" *ngIf="!isEditMode">
                    {{letterBodyText.closing_text}}
                </p>
            </div>

            <!-- Bank Details and QR Code Section -->
            <!-- Add this after the table section and before closing text -->

            <div class="row" style="margin-top: 30px; page-break-inside: avoid;">
                <!-- Bank Details & QR Code -->
                <div class="col-7" style="padding-right: 15px;">
                    <div
                        style="border: 2px solid #000; padding: 15px; height: 100%; display: flex; justify-content: space-between; align-items: flex-start;">
                        <!-- Bank Details Text -->
                        <div style="flex: 1;">
                            <div style="font-weight: bold; margin-bottom: 8px; font-size: 14px;">Bank Details:</div>
                            <div style="line-height: 1.6; font-size: 12px;">
                                <div><strong>A/C Name:</strong> HINDUSTAN PRAKASHAN SANSTHA</div>
                                <div><strong>A/C No.:</strong> 20109800154</div>
                                <div><strong>IFSC No.:</strong> MAHB0000318</div>
                                <div><strong>Bank Name:</strong> Bank of Maharashtra</div>
                                <div><strong>Branch:</strong> Prabhadevi, Mumbai - 400025</div>
                            </div>
                        </div>

                        <!-- QR Code -->
                        <div style="margin-left: 15px; display: flex; align-items: center;">
                            <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code"
                                style="width: 120px; height: 120px; border: 1px solid #ddd;">
                        </div>
                    </div>
                </div>

                <!-- Right side empty space (col-5) -->
                <div class="col-5"></div>
            </div>

            <div class="signature-section">

                <p style="margin-top: 40px; margin-right:40px;">स्नेहांकित,</p>
            </div>

            <div class="signature-section">

                <p style="margin-top: 30px;">(जाहिरात विभाग प्रमुख)</p>
            </div>
        </div>

        <!-- Footer Section -->
        <!-- <div class="footer-section">
            <div class="footer-note">
                (धनादेश वटल्यावरच पावती अधिकृत होईल)
            </div>
            <div class="footer-signature">
                व्यवस्थापक / लेखापाल
            </div>
        </div> -->
    </div>

    <!-- Edit Control Buttons -->
    <div class="edit-controls"
        style="margin-bottom: 15px; text-align: right; padding: 10px; background-color: #f5f5f5; border-radius: 5px;">


        <button *ngIf="!isEditMode" (click)="toggleEditMode()" class="btn btn-primary" style="margin-right: 5px;">
            <i class="fa fa-edit"></i> संपादित करा (Edit)
        </button>

        <button *ngIf="isEditMode" (click)="saveLetterTemplaterep()" [disabled]="isSaving" class="btn btn-success"
            style="margin-right: 5px;">
            <i class="fa fa-save"></i> {{ isSaving ? 'जतन करत आहे...' : 'जतन करा (Save)' }}
        </button>

        <button *ngIf="isEditMode" (click)="toggleEditMode()" class="btn btn-secondary" style="margin-right: 5px;">
            <i class="fa fa-times"></i> रद्द करा (Cancel)
        </button>

        <button *ngIf="isEditMode" (click)="resetToDefault()" class="btn btn-warning">
            <i class="fa fa-refresh"></i> डिफॉल्ट (Reset)
        </button>
    </div>
</div>